import React from 'react';
import { ORDER_INVOICE_ISSUING_TYPE} from '@Constants/';
import {isEqual} from '@Util/utils';
import { Alert, Stack } from '@curves/ui-base';

/**
 * 訂單發票類型資訊組件
 * 
 * 功能：
 * - 顯示發票開立類型相關資訊
 * - 根據不同類型顯示對應文字
 * - 支援手開發票的特殊提示
 * 
 * @component
 * @param {Object} props - 組件屬性
 * @param {number} props.issuingType - 發票開立類型
 * @param {string} props.invoiceCarrierTypeText - 載具類型文字
 * @param {string} props.issuingTypeText - 開立類型文字
 * @returns {JSX.Element} 發票類型資訊
 */
const OrderInvoiceTypeInfo = ({ issuingType, invoiceCarrierTypeText, issuingTypeText }) => {
    const text = isEqual(issuingType, ORDER_INVOICE_ISSUING_TYPE.DUPLICATEUNIFORMINVOICE)
        ? invoiceCarrierTypeText
        : issuingTypeText || '無相關資料';
    return (
        <Stack alignItems="start" spacing={1}>
            {text}
            {isEqual(issuingType, ORDER_INVOICE_ISSUING_TYPE.MANUAL) && (
                <Alert className="alert-justify-content-start" color="info" severity="info">
                    選擇手開發票，發票異動需由店舖自行處理。
                </Alert>
            )}
        </Stack>
    );
};
export default OrderInvoiceTypeInfo;
